import apiClient from "./api";
const LISTAS_API_BASE_URL = "/listaPrecios";

class ListasService {
  getListas() {
    return apiClient.get(LISTAS_API_BASE_URL);
  }

  deleteLista(idLista) {
    return apiClient.delete(`${LISTAS_API_BASE_URL}/${idLista}`);
  }

  agregarLista(lista) {
    return apiClient.post(LISTAS_API_BASE_URL, lista);
  }

}

export default new ListasService();
